import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "coll-props"
}
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")

  return ($data.coll)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("b", null, "Name:", -1 /* HOISTED */)),
            _createTextVNode(_toDisplayString($data.coll.name), 1 /* TEXT */)
          ]),
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("b", null, "Description:", -1 /* HOISTED */)),
            _createTextVNode(_toDisplayString($data.coll.description), 1 /* TEXT */)
          ]),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("b", null, "Vectorizer:", -1 /* HOISTED */)),
            _createTextVNode(_toDisplayString($data.coll.vectorizer), 1 /* TEXT */)
          ]),
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("b", null, "Objects Count:", -1 /* HOISTED */)),
            _createTextVNode(_toDisplayString($data.coll.total), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("table", null, [
          _cache[4] || (_cache[4] = _createElementVNode("caption", null, "Properties", -1 /* HOISTED */)),
          _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Prop Name"),
              _createElementVNode("th", null, "Description"),
              _createElementVNode("th", null, "Data Type"),
              _createElementVNode("th", null, "Searchable"),
              _createElementVNode("th", null, "Filterable"),
              _createElementVNode("th", null, "Tokenization"),
              _createElementVNode("th", null, "Vectorizer")
            ])
          ], -1 /* HOISTED */)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.coll.properties, (prop) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: prop.name
              }, [
                _createElementVNode("td", null, _toDisplayString(prop.name), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.description), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.dataType[0]), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.indexSearchable), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.indexFilterable), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.tokenization || 'None'), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(prop.vectorizer || 'None'), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.coll.v_config, (iconf, iname) => {
            return (_openBlock(), _createElementBlock("div", { key: iname }, [
              _createElementVNode("table", null, [
                _createElementVNode("caption", null, _toDisplayString(iname) + " - index config ", 1 /* TEXT */),
                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Key"),
                    _createElementVNode("th", null, "Value")
                  ])
                ], -1 /* HOISTED */)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(iconf['vector_index_config']), (prop) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: prop[0]
                    }, [
                      _createElementVNode("td", null, _toDisplayString(prop[0]), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(prop[1] || 'None'), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("table", null, [
                _createElementVNode("caption", null, _toDisplayString(iname) + " - vectorizer", 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Key"),
                    _createElementVNode("th", null, "Value")
                  ])
                ], -1 /* HOISTED */)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(iconf['vectorizer']), (prop) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: prop[0]
                    }, [
                      _createElementVNode("td", null, _toDisplayString(prop[0]), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(prop[1] || 'None'), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          ($data.coll.vi_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("table", null, [
                  _createElementVNode("caption", null, "Vector Index Config (" + _toDisplayString($data.coll.vi_type) + ")", 1 /* TEXT */),
                  _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Key"),
                      _createElementVNode("th", null, "Value")
                    ])
                  ], -1 /* HOISTED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($data.coll.vi_config), (prop) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: prop.key
                      }, [
                        _createElementVNode("td", null, _toDisplayString(prop[0]), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(prop[1] || 'None'), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _cache[9] || (_cache[9] = _createElementVNode("caption", null, "Inverted Index Config", -1 /* HOISTED */)),
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Key"),
                  _createElementVNode("th", null, "Value")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($data.coll.ii_config), (prop) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: prop[0]
                  }, [
                    _createElementVNode("td", null, _toDisplayString(prop[0]), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(prop[1]), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
}